import {getLegalInformationData} from '../api/api' ;

// SET_LEGAL_INFORMATION
export const setLegalInformation = (legalInformationData) => ({
    type: 'SET_LEGAL_INFORMATION',
    data: legalInformationData
});

// GET_LEGAL_INFORMATION
export const getLegalInformation = (legalInformationData) => ({
    type: 'GET_LEGAL_INFORMATION',
    data: legalInformationData
});


export const starGetLegalInformation = (idBenef = '', idPartner = '') => {
    return () => {
        return getLegalInformationData(idBenef, idPartner) ;
    }
};


// WEBPACK FOOTER //
// ./src/actions/legalInformation.js